import Linkify from 'linkify-react';
import styled from '@emotion/styled';
import { object, node, oneOfType, string, bool } from 'prop-types';
import linkifyHtml from "linkify-html";

const StyledDiv = styled("div")(({ theme }) => (
  {
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    a: {
      color: theme.colors.primaryFont,
      textDecoration: 'underline',
      '&:hover': {
        color: theme.colors.primaryFont
      }
    }
  }
));

const TextWithLinks = ({ options, children, renderAsHtml }) => {
  if (children === null || children === undefined) {
    return <></>;
  }

  if (renderAsHtml) {
    const linkified = linkifyHtml(children, options);
    return <StyledDiv dangerouslySetInnerHTML={{ __html: linkified }} />;
  }

  return (
    <StyledDiv>
      <Linkify options={options}>{children}</Linkify>
    </StyledDiv>
  );
};

TextWithLinks.propTypes = {
  children: oneOfType([node, string]),
  options: object.isRequired,
  renderAsHtml: bool
};

TextWithLinks.defaultProps = {
  options: { target: '_blank', ignoreTags: ['a'] },
  renderAsHtml: false
};

export default TextWithLinks;
